import gameState from "slotworks/model/game-state";
import Components from "slotworks/components/components";
import betModel from "slotworks/model/bets/bet-model";
import G288SpinRecord from "integration/spin-record";
import Rectangle from "slotworks/utils/geom/rectangle";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";

export function isBigWinInBaseGame():boolean {
    const record = gameState.getCurrentGame().getCurrentRecord() as G288SpinRecord;
    return (!gameState.getCurrentGame().inFreespinsGame && 
                Components.bigWin.isBigWin(record.creditsWon, betModel.getTotalBet())
                && !record.freespinsTriggered);
}

export function LimitBitmapText(text: PIXI.Text| PIXI.extras.BitmapText, limits: Rectangle) {
    if(!limits || !(text instanceof PIXI.extras.BitmapText)) return;
    const bitmapText = (text as any) as PIXI.extras.BitmapText;
    const fontSize: number = Number((bitmapText.font as any).size);
    let fontDecrease: number = 0;
    while(fontSize && bitmapText.textWidth > limits.width && fontDecrease < 40) {
        fontDecrease += 4;
        (bitmapText.font as any).size = fontSize - fontDecrease;
        (bitmapText as any).updateText();
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/utils/utils.ts